import { Dialog } from "@components/dialog"
import { BlockIcon } from "@icons/block-icon"
import { RefreshIcon } from "@icons/refresh-icon"
import { useEffect, useState } from "react"
import { useBlocker } from "react-router-dom"
import { usePreventNav } from "../../app/prevent-navigation-ctx"

export const PreventNavigation = () => {
	const [when, setWhen] = useState(false)
	const { forms, setForms } = usePreventNav()

	useEffect(() => {
		setWhen(forms.some((element) => element.isDirty))
	}, [forms])

	const blocker = useBlocker(when)

	if (!blocker || blocker.state !== "blocked") return null

	return (
		<Dialog
			title="Some changes are unsaved"
			isDestructive
			onConfirm={() => {
				blocker.proceed?.()
				setForms([])
			}}
			onClose={() => blocker.reset?.()}
			closeIcon={BlockIcon}
			confirmLabel="Discard changes"
			confirmIcon={RefreshIcon}
		>
			Do you really want to leave ?
		</Dialog>
	)
}
